export const LOAD_OEM = "LOAD_OEM";
export const LOAD_OEM_SUCCESS = "LOAD_OEM_SUCCESS";
export const LOAD_OEM_ERROR = "LOAD_OEM_ERROR";
